var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useReducer } from 'react';
import { ConfigurationState } from '../types/ConfigurationState';
const initialState = {
    authenticated: false,
    authService: null,
    configurationState: ConfigurationState.Unconfigured,
    fatalError: undefined,
    fatalReason: undefined,
    legacyMode: false,
    postAuthCallback: (user) => __awaiter(this, void 0, void 0, function* () { return console.log('no postAuthCallback defined'); }),
    redirectInProgress: false,
    redirectTarget: null,
    renderChildren: false,
    renderChildrenAfterLogout: false,
    tokenRefreshRequested: false,
    user: null,
    wasLoggedIn: false,
    debugMode: false,
    userActivityTimestamp: new Date().getTime(),
    lastTokenRefreshTimestamp: new Date().getTime()
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'AUTHENTICATED':
            return Object.assign({}, state, { authenticated: true, user: action.user });
        case 'BEGIN_REDIRECT':
            return Object.assign({}, state, { redirectInProgress: true, redirectTarget: action.redirectTarget });
        case 'CANCEL_REDIRECT':
            return Object.assign({}, state, { redirectInProgress: false });
        case 'CONFIGURING':
            return Object.assign({}, state, { configurationState: ConfigurationState.Configuring, debugMode: action.debugMode, legacyMode: action.legacyMode, postAuthCallback: action.postAuthCallback, renderChildrenAfterLogout: action.renderChildrenAfterLogout });
        case 'CONFIGURED':
            return Object.assign({}, state, { configurationState: ConfigurationState.Configured });
        case 'CONFIGURE_AUTH_SERVICE':
            return Object.assign({}, state, { authService: action.authService });
        case 'FATAL_ERROR':
            const { reason, error } = action;
            return Object.assign({}, state, { fatalReason: reason, fatalError: error });
        case 'FORBIDDEN':
            return Object.assign({}, state, { authenticated: false, wasLoggedIn: true, reason: action.reason, user: null });
        case 'GLOBAL_LOGIN_DETECTED':
            return Object.assign({}, state, { wasLoggedIn: false });
        case 'LOGOUT':
            return Object.assign({}, state, { authenticated: false, wasLoggedIn: true, loggedOutMessage: action.message, user: null });
        case 'RECORD_USER_ACTIVITY':
            return Object.assign({}, state, { userActivityTimestamp: new Date().getTime() });
        case 'RENDER_CHILDREN':
            return Object.assign({}, state, { renderChildren: true });
        case 'SHOW_LOGIN_MODAL':
            return state;
        case 'TOKEN_REFRESH_REQUESTED':
            return Object.assign({}, state, { tokenRefreshRequested: true });
        case 'TOKEN_REFRESH_SUCCESS':
            return Object.assign({}, state, { tokenRefreshRequested: false, user: action.user, lastTokenRefreshTimestamp: new Date().getTime() });
        default:
            return state;
    }
}
export default function usePrivateReducer() {
    return useReducer(reducer, initialState);
}
